import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreatePage = props => {
  return (
    <Create
      title='Create Public Page'
      fields={fields}
      apiPath='admin/cms_pages'
      successRedirectPath={resource => `/cms/pages/${resource.id}/edit`}
      buildMenuItems={menuItems}
      resource={{
        requires_membership: false
      }}
    />
  )
}

export default CreatePage
